import { useEffect } from "react"
import { useLocation } from "react-router-dom"
import { getBackgroundMusicEnabled } from "@/utils/backgroundMusicPreference"
import { startBackgroundMusic, stopBackgroundMusic } from "@/utils/audioManager"

// The login screen stays silent — music only kicks in once the player is past it.
const silentRoutes = ["/login"]

export const useBackgroundMusic = () => {
  const { pathname } = useLocation()
  const isSilentRoute = silentRoutes.includes(pathname)

  useEffect(() => {
    if (isSilentRoute) {
      stopBackgroundMusic()
      return
    }

    const tryStartMusic = () => {
      if (getBackgroundMusicEnabled()) {
        startBackgroundMusic()
      } else {
        stopBackgroundMusic()
      }
    }

    const handlePreferenceChange = (event: Event) => {
      const enabled = (event as CustomEvent<boolean>).detail
      if (enabled) startBackgroundMusic()
      else stopBackgroundMusic()
    }

    tryStartMusic()

    // Browsers may block autoplay until the first user gesture.
    const handleFirstInteraction = () => {
      tryStartMusic()
    }

    document.addEventListener("pointerdown", handleFirstInteraction, true)
    window.addEventListener(
      "background-music-preference-changed",
      handlePreferenceChange
    )
    return () => {
      document.removeEventListener("pointerdown", handleFirstInteraction, true)
      window.removeEventListener(
        "background-music-preference-changed",
        handlePreferenceChange
      )
      stopBackgroundMusic()
    }
  }, [isSilentRoute])
}
